import API from 'services/TAPS_API';
//todo: переделай все таки с параметрам, вдруг для других обращений тоже появятся черновики
export default function getMovementReportList() {
  return API.request({
    method: 'GET',
    url: `/notification/1112520/list`,
  });
}
